<template>
  <div class="pl-5 pr-5">
    <header class="section-header section-header-news">
      <!-- <h2 class="text-dark font-weight-bold">
        <mark data-aos="highlight-text" data-aos-delay="250" class="aos-init aos-animate"> Noticias </mark>
      </h2> -->
      <h3 class="text-transparencia ">
        NOTICIAS
      </h3>
      <hr style="border-top-color: rgba(0, 0, 0, 0.15) !important;" />
    </header>

    <div id="slider-noticias">
      <template v-for="(noticia, index) in noticias">
        <div class="pl-2 pr-2" :key="index">
          <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
            <div class="card-img-top w-100 text-center">
              <a :href="'home/noticia/' + noticia.noticiaId">
                <img class="img-fluid w-100 rounded cimage-slider" :src="`${filesUrl + noticia.rutaImagenMiniatura}`" :alt="noticia.titulo" />
              </a>
            </div>
            <div class="card-body p-2" style="">
              <!-- <small class="text-light fs-12" :datetime="noticia.fechaNoticia"> {{ noticia.fechaNoticia | date }} </small> -->
              <div class="d-flex justify-content-center text-center" style="height:6.6rem !important;overflow:hidden">
                <a :href="'home/noticia/' + noticia.noticiaId">
                  <h6 class="card-title fs-15 text-transparencia">{{ noticia.titulo }}</h6>
                </a>
              </div>
            </div>
            <div class="card-footer text-right pt-0">
              <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'home/noticia/' + noticia.noticiaId">Leer más<i class="fa fa-search-plus ml-1"></i></a>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="col-md-12 text-center mt-5">
      <router-link to="/home/noticias" class="btn btn-primary btn-transparencia">Ver todo</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "view-noticias",
  // metaInfo: {
  //   title: "Inicio",
  // },
  components: {},
  data: () => ({
    noticias: [],
  }),
  methods: {
    fetchNews: function() {
      this.$http.get(this.apiRoute("Common", "ListNoticiasAll")).then(function(response) {
        if (!response.body.error) {
          this.noticias = response.body.data;
        }
        startSlider("slider-noticias", [4, 3, 3, 2, 2, 1]);
      });
    },
  },
  mounted: function() {
    this.fetchNews();
  },
};
</script>
